var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDragHandle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.5,
    stroke: "#A4A4A4",
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#A4A4A4",
    d: "M7.623 3.154a.539.539 0 0 1 .694-.051l.06.05 1.96 1.919a.542.542 0 0 1 .01.765.539.539 0 0 1-.702.06l-.061-.05L8 4.296l-1.584 1.55a.539.539 0 0 1-.703.043l-.06-.053a.542.542 0 0 1-.043-.705l.053-.06 1.96-1.918zm0 9.692c.19.187.484.204.694.051l.06-.05 1.96-1.919a.542.542 0 0 0 .01-.765.539.539 0 0 0-.702-.06l-.061.05L8 11.704l-1.584-1.55a.539.539 0 0 0-.703-.043l-.06.053a.542.542 0 0 0-.043.705l.053.06 1.96 1.918z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragHandle);
export default __webpack_public_path__ + "static/media/DragHandle.4e1a3f57.svg";
export { ForwardRef as ReactComponent };